<template>
  <div class="content-container">
    <!-- search component -->
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">Bộ phận</div>
              <el-select
                v-model="searchParams.type"
                placeholder="Chọn bộ phận"
                filterable
                no-match-text="Không có dữ liệu"
                no-data-text="Không có dữ liệu"
                @change="onSearch"
              >
                <!-- <el-option :value="null" label="Chọn" /> -->
                <el-option
                  v-for="(option, index) in typeOptions"
                  :key="index"
                  :value="option.value"
                  :label="option.label"
                />
              </el-select>
            </div>
          </div>
          <div class="das-form-col col-3">
            <div class="das-form-input">
              <div class="label">Loại</div>
              <el-select
                v-model="searchParams.applyType"
                placeholder="Chọn loại"
                filterable
                no-match-text="Không có dữ liệu"
                no-data-text="Không có dữ liệu"
                @change="onSearch"
              >
                <el-option
                  v-for="(option, index) in applyTypeOptions"
                  :key="index"
                  :value="option.value"
                  :label="option.label"
                />
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Grid -->
    <div class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="searchParams.type == 1 ? columns2 : columns"
        :rows="rows"
        class="agGrid"
        dom-layout="scroll"
        row-selection="single"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        @selectionChanged="onSelectionChanged"
      />
    </div>

    <!-- Pagination -->
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>

    <!-- Btns -->
    <div class="button-containers">
      <button type="button" class="btn primary small" @click="onCreate">
        Thêm khuyến mại
      </button>
      <button
        type="button"
        class="btn primary small"
        :disabled="selectedRows.length !== 1"
        @click="onUpdate"
      >
        Cập nhật khuyến mại
      </button>
      <button
        type="button"
        class="btn primary small outline"
        :disabled="selectedRows.length <= 0"
        @click="onDelete"
      >
        Xóa khuyến mại
      </button>
    </div>

    <!-- Dialog -->
    <PromotionFormDialog
      v-model="dialogPromotionFormVisible"
      :promotion-id="props.promotionId"
      :type="props.type"
      :search-params="searchParams"
      @refresh="onSearch"
    />
  </div>
</template>

<script>
import PromotionFormDialog from './PromotionFormDialog.vue'
import paginationMixin from '@/mixins/paginationMixin'
import {
  DEPARTMENT_VALUE,
  PROMOTION_STATUS_VALUE,
  PROMOTION_TYPE_VALUE
} from './constant'
import { dateFormatter } from '@/utils/dataFormatter'

import { fnGetCodeBaseList } from './utils'
import {
  deleteNewPromotionList,
  deleteVoucherList,
  getNewPromotionList,
  getVoucherList,
  exportVoucherTicket,
  exportVoucherRoom
} from '@/api/booking_service/promotion'
import { notifyError, notifySuccess } from '@/utils/toast'

export default {
  components: { PromotionFormDialog },
  mixins: [paginationMixin],
  props: {},
  data() {
    return {
      searchParams: {
        type: null, // departure type pms (le tan): 0 , ticket (ve): 1
        applyType: null // promotion type: 0 (voucher), 1 (promotion)
      },
      defaultSearchParams: {
        type: null,
        applyType: null
      },
      typeOptions: [
        { value: DEPARTMENT_VALUE.RECEPTIONIST, label: 'Lễ tân' },
        { value: DEPARTMENT_VALUE.TICKET, label: 'Vé' }
      ],
      applyTypeOptions: [
        { value: PROMOTION_TYPE_VALUE.VOUCHER, label: 'Voucher' },
        { value: PROMOTION_TYPE_VALUE.PROMOTION, label: 'Promotion' }
      ],

      rows: [],
      selectedRows: [],

      promotionCodebaseList: [],

      // dialog
      dialogPromotionFormVisible: false,
      props: {
        promotionId: null,
        type: null
      }
    }
  },

  computed: {
    columns() {
      const baseColumns = [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 150,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: 'Loại',
          field: 'type',
          tooltipValueGetter: params => {
            let renderText = ''
            switch (params.value) {
              case PROMOTION_TYPE_VALUE.VOUCHER:
                renderText = 'Voucher'
                break
              case PROMOTION_TYPE_VALUE.PROMOTION:
                renderText = 'Promotion'
                break
              default:
                break
            }
            return renderText
          },
          cellRenderer: params => {
            let renderText = ''
            switch (params.value) {
              case PROMOTION_TYPE_VALUE.VOUCHER:
                renderText = 'Voucher'
                break
              case PROMOTION_TYPE_VALUE.PROMOTION:
                renderText = 'Promotion'
                break
              default:
                break
            }
            return renderText
          },
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          tooltipValueGetter: params => {
            let renderText = ''
            switch (params.value) {
              case PROMOTION_STATUS_VALUE.APPLYING:
                renderText = 'Đang áp dụng'
                break
              case PROMOTION_STATUS_VALUE.STOP_APPLYING:
                renderText = 'Ngưng áp dụng'
                break
              default:
                break
            }
            return renderText
          },
          cellRenderer: params => {
            let renderText = ''
            switch (params.value) {
              case PROMOTION_STATUS_VALUE.APPLYING:
                renderText = 'Đang áp dụng'
                break
              case PROMOTION_STATUS_VALUE.STOP_APPLYING:
                renderText = 'Ngưng áp dụng'
                break
              default:
                break
            }
            return renderText
          },
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.startDate'),
          field: 'start_date',
          valueFormatter: params => {
            return params.value ? dateFormatter(params.value) : null
          },
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.endDate'),
          valueFormatter: params => {
            return params.value ? dateFormatter(params.value) : null
          },
          field: 'end_date',
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          maxWidth: 120
        }
      ]

      if (this.searchParams.applyType === PROMOTION_TYPE_VALUE.PROMOTION) {
        baseColumns.push({
          headerName: 'Điều kiện áp dụng',
          field: 'promotion_type',
          valueFormatter: params => {
            return (
              this.promotionCodebaseList.find(
                item => item.code === params.value
              )?.['desc'] || null
            )
          },
          minWidth: 120,
          maxWidth: 250,
          wrapText: true,
          autoHeight: true
        })
      } else if (this.searchParams.applyType === PROMOTION_TYPE_VALUE.VOUCHER) {
        baseColumns.push({
          headerName: 'Prefix',
          field: 'prefix',
          tooltipField: 'prefix',
          minWidth: 100,
          maxWidth: 120
        })
      }

      baseColumns.push({
        headerName: 'Ghi chú',
        field: 'note',
        // cellClass: "grid-cell-centered",
        minWidth: 150
      })

      // Only add download column if viewing vouchers
      if (this.searchParams.applyType === PROMOTION_TYPE_VALUE.VOUCHER) {
        baseColumns.push({
          headerName: '',
          field: 'download',
          cellRenderer: params => {
            const div = document.createElement('div')
            div.style.cssText = 'display: flex; justify-content: center; align-items: center; height: 100%;'
            div.innerHTML = '<i class="el-icon-download" style="color: #357456; font-size: 22px; cursor: pointer;"></i>'
            div.addEventListener('click', () => {
              this.downloadVoucherList(params.data)
            })
            return div
          },
          minWidth: 60,
          maxWidth: 60,
          resizable: false
        })
      }

      return baseColumns
    },
    columns2() {
      const baseColumns = [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          maxWidth: 150,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          tooltipValueGetter: params => {
            let renderText = ''
            switch (params.value) {
              case PROMOTION_STATUS_VALUE.APPLYING:
                renderText = 'Đang áp dụng'
                break
              case PROMOTION_STATUS_VALUE.STOP_APPLYING:
                renderText = 'Ngưng áp dụng'
                break
              default:
                break
            }
            return renderText
          },
          cellRenderer: params => {
            let renderText = ''
            switch (params.value) {
              case PROMOTION_STATUS_VALUE.APPLYING:
                renderText = 'Đang áp dụng'
                break
              case PROMOTION_STATUS_VALUE.STOP_APPLYING:
                renderText = 'Ngưng áp dụng'
                break
              default:
                break
            }
            return renderText
          },
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.startDate'),
          field: 'start_date',
          valueFormatter: params => {
            return params.value ? dateFormatter(params.value) : null
          },
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.endDate'),
          valueFormatter: params => {
            return params.value ? dateFormatter(params.value) : null
          },
          field: 'end_date',
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          maxWidth: 120
        }
      ]

      if (this.searchParams.applyType === PROMOTION_TYPE_VALUE.VOUCHER) {
        baseColumns.push({
          headerName: 'Điều kiện vé',
          field: 'voucher_ticket_type',
          valueFormatter: params => {
            return (
              this.promotionCodebaseList.find(
                item => item.code === params.value
              )?.['desc'] || params.value || null
            )
          },
          minWidth: 120,
          maxWidth: 250,
          wrapText: true,
          autoHeight: true
        })
      }

      baseColumns.push({
        headerName: 'Ghi chú',
        field: 'note',
        // cellClass: "grid-cell-centered",
        minWidth: 150
      })

      // Only add download column if viewing vouchers
      if (this.searchParams.applyType === PROMOTION_TYPE_VALUE.VOUCHER) {
        baseColumns.push({
          headerName: '',
          field: 'download',
          cellRenderer: params => {
            const div = document.createElement('div')
            div.style.cssText = 'display: flex; justify-content: center; align-items: center; height: 100%;'
            div.innerHTML = '<i class="el-icon-download" style="color: #357456; font-size: 22px; cursor: pointer;"></i>'
            div.addEventListener('click', () => {
              this.downloadVoucherList(params.data)
            })
            return div
          },
          minWidth: 60,
          maxWidth: 60,
          resizable: false
        })
      }

      return baseColumns
    }
  },

  async beforeMount() {
    this.promotionCodebaseList = await fnGetCodeBaseList()
    this.searchParams.type =
      this.typeOptions[0]?.value ?? DEPARTMENT_VALUE.RECEPTIONIST
    this.searchParams.applyType =
      this.applyTypeOptions[0]?.value ?? PROMOTION_TYPE_VALUE.VOUCHER
    this.defaultSearchParams.type =
      this.typeOptions[0]?.value ?? DEPARTMENT_VALUE.RECEPTIONIST
    this.defaultSearchParams.applyType =
      this.applyTypeOptions[0]?.value ?? PROMOTION_TYPE_VALUE.VOUCHER
    await this.fnGetPromotionList()
  },

  methods: {
    // handle event
    onSearch() {
      this.pageParams.pageNum = 1
      this.fnGetPromotionList()
    },
    onReset() {
      this.searchParams = Object.assign({}, this.defaultSearchParams)
      this.onSearch()
    },

    onCreate() {
      this.props.promotionId = null
      this.dialogPromotionFormVisible = true
    },
    onUpdate() {
      this.props.promotionId = this.selectedRows[0]?.id
      // Set type based on department and applyType combination
      if (this.searchParams.type === DEPARTMENT_VALUE.TICKET) {
        this.props.type = 1
      } else {
        this.props.type = 0
      }
      this.dialogPromotionFormVisible = true
    },
    onDelete() {
      this.$vxConfirm(
        'Bạn chắc chắn muốn xoá (các) khuyến mại này?',
        this.fnDeletePromotion
      )
    },

    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetPromotionList()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetPromotionList()
    },

    onSelectionChanged(value) {
      this.selectedRows = value
    },

    // handle api call
    async fnGetPromotionList() {
      const query = {
        pageNum: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize
      }

      let res
      try {
        if (this.searchParams.applyType === PROMOTION_TYPE_VALUE.PROMOTION) {
          // Call promotion-new API
          if (this.searchParams.type === DEPARTMENT_VALUE.RECEPTIONIST) {
            query.applyType = 1
          } else if (this.searchParams.type === DEPARTMENT_VALUE.TICKET) {
            query.applyType = 2
          }
          res = await getNewPromotionList(query)
        } else if (
          this.searchParams.applyType === PROMOTION_TYPE_VALUE.VOUCHER
        ) {
          // Call voucher API
          if (this.searchParams.type === DEPARTMENT_VALUE.RECEPTIONIST) {
            query.applyType = 1
          } else if (this.searchParams.type === DEPARTMENT_VALUE.TICKET) {
            query.applyType = 2
          }
          res = await getVoucherList(query)
        }

        this.rows = (res.data || []).map(row => ({
          ...row,
          type: this.searchParams.applyType
        }))
        this.pageParams.totalPage = Math.ceil(
          res.total / this.pageParams.pageSize
        )
      } catch (error) {
        const message = error.response?.data?.message
        notifyError(message)
      }
    },
    async fnDeletePromotion() {
      let res
      try {
        if (this.searchParams.applyType === PROMOTION_TYPE_VALUE.PROMOTION) {
          res = await deleteNewPromotionList({
            ids: this.selectedRows.map(item => item.id)
          })
        } else if (
          this.searchParams.applyType === PROMOTION_TYPE_VALUE.VOUCHER
        ) {
          res = await deleteVoucherList({
            ids: this.selectedRows.map(item => item.id)
          })
        }
        notifySuccess(res.message)
        this.selectedRows = []
        this.onSearch()
      } catch (error) {
        console.error(error)
        const message = error.response?.data?.message || 'default'
        notifyError(message)
      }
    },
    async downloadVoucherList(rowData) {
      try {
        let response
        let fileName
        // Determine which API to call based on department type
        if (this.searchParams.type === DEPARTMENT_VALUE.TICKET) {
          // Call export voucher ticket API
          response = await exportVoucherTicket(rowData.id)
          fileName = `Voucher_${rowData.code}_Ticket_List.xlsx`
        } else if (this.searchParams.type === DEPARTMENT_VALUE.RECEPTIONIST) {
          // Call export voucher room API
          response = await exportVoucherRoom(rowData.id)
          fileName = `Voucher_${rowData.code}_Room_List.xlsx`
        }

        // Create blob and download file
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        notifySuccess('Tải xuống thành công')
      } catch (error) {
        console.error(error)
        const message = error.response?.data?.message || 'Tải xuống thất bại'
        notifyError(message)
      }
    }
  }
}
</script>
